export default __webpack_public_path__ + "static/1765-c4abf20e8e8624cfc061e50e0d2db371.gif";